import styled from '@emotion/styled';

export const AboutWrapper = styled('div')(
  () => `
    display: flex;
    
    .infoBlock {
        margin-right: 80px;
    }
`,
);

export const TableWrapper = styled('div')(
  () => `
    margin-top: 30px
    `,
);
